import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class UidInterceptor implements HttpInterceptor
{
	constructor() { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
	{
		try
		{
			// Read deviceUid directly from localStorage rather than from currentUserValue.
			// currentUserValue is null after logout (including auto-logout on 401), but
			// deviceUid is intentionally kept alive across logouts so the backend can
			// recognise this browser and skip 2FA for 7 days.
			const deviceUid = localStorage.getItem('deviceUid');
			if (deviceUid)
			{
				request = request.clone({
					setHeaders: {
						uid: deviceUid
					}
				});
			}
			return next.handle(request);
		}
		catch (error)
		{
			return next.handle(request);
		}
	}
}
